// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__xkagJ","title":"InfoRow_title__2iYJF"};